import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { AppContext } from "../utilities/context";
import AlertCustom from "./AlertCustom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Styles from "../../public/assets/css/main.css";
import logo from "../../public/assets/img/avatarNavegante256x256.png";
import Footer from "./Footer";
import AppBar from "@mui/material/AppBar";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Drawer from "@mui/material/Drawer";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";

const naveganteTheme = createTheme({
  // status: {
  //   danger: "#e53e3e",
  // },
  // palette: {
  //   primary: {
  //     main: "#6b7a8f",
  //     darker: "#053e85",
  //     contrastText: "#ffcc00",
  //   },
  //   neutral: {
  //     main: "#64748B",
  //     contrastText: "#fff",
  //   },
  // },
});

const drawerWidth = 240;

function UserMenu(props) {
  let navItems;
  navItems = [
    {
      label: "Home",
      link: "/",
      localeId: "app.header.home.label",
      public: true,
    },
    {
      label: "Programas anteriores",
      link: "/shows",
      localeId: "app.header.replay.label",
      public: true,
    },
  ];
  // if (props.context && props.context.user) {
  //   navItems.push({
  //     label: "Account",
  //     link: "/account",
  //     localeId: "app.header.account.label",
  //     public: true,
  //   });
  // } else {
  //   navItems.push({
  //     label: "Login",
  //     link: "/login",
  //     localeId: "app.header.login.label",
  //     public: true,
  //   });
  // }
  return navItems.map((item) => (
    <Link key={item.label} to={item.link} className={"headerMenu"}>
      <FormattedMessage id={item.localeId} defaultMessage={item.label} />
    </Link>
  ));
}

function Preloader(props) {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={false}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

const Layout = ({ children }) => {
  const context = useContext(AppContext);
  const [mobileOpen, setMobileOpen] = useState(false);
  const container = undefined;

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const AlertItem = () => {
    if (context.alert) {
      return context.alert.map((d, index) => (
        <AlertCustom
          key={index}
          show={d.open}
          message={d.message}
          severity={d.severity}
          onClose={() => context.updateAlertState([{ open: false }])}
        />
      ));
    }
    return null;
  };

  useEffect(() => {
    console.log("Holanda");
  }, []); // The empty dependency array means this effect will only run once (equivalent to componentDidMount)

  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{ textAlign: "center", paddingTop: "16px" }}
    >
      <img
        src={logo}
        className="App-logo mrkPT1em"
        alt="logo"
        style={{ width: "40px" }}
      />
      <Typography variant="h6" sx={{ my: 2 }}>
        Navegante
      </Typography>
      <Divider />
      <List className={"drawerListMenu"}>
        <UserMenu drawer={true} context={context} />
      </List>
    </Box>
  );

  return (
    <ThemeProvider theme={naveganteTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Preloader />
        <AppBar component="nav" color="primary" sx={{ height: "64px" }}>
          <Toolbar sx={{ height: "64px" }}>
            <Link to={"/"}>
              <img src={logo} className={"AppLogo"} alt="logo" />
            </Link>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, display: { xs: "block", sm: "block" } }}
            >
              Navegante
            </Typography>
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
              <UserMenu context={context} />
            </Box>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box component="nav">
          <Drawer
            anchor="right"
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
        </Box>
        <Container
          maxWidth={false}
          disableGutters={false}
          className={"mainContainer"}
        >
          <AlertItem />
          <Box component="main">{children}</Box>
        </Container>
      </Box>
      <Footer />
    </ThemeProvider>
  );
};

export default Layout;
